import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'

const LoanUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelUpdate,
  // form fields
  loanName, onLoanNameChange, loanNameError, setLoanNameError,
  loanType, onLoanTypeChange, loanTypeError, setLoanTypeError, loanTypeList,
  appFlavor, onAppFlavorChange, appFlavorError, setAppFlavorError, appFlavorList,
  loanPurpose, onLoanPurposeChange, loanPurposeError, setLoanPurposeError, loanPurposeList, sectorList,
  loanSubType, onLoanSubTypeChange, loanSubTypeError, setLoanSubTypeError, loanSubTypeList,
  loanAmountF, onLoanAmountFChange, loanAmountFError, setLoanAmountFError,
  loanTenure, onTenureMonthsChange, tenureMonthsError, setTenureMonthsError, capex, onCapexChange,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update loan'
    buttonLabel='Update loan'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelUpdate}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top c_ln_crt'>
      <div className='col'>
      <InputTextSF type='text' name='s_name' required={true} maxLength={12}
          label='Loan name' autoFocus={true}
          value={loanName} onChange={onLoanNameChange}
          error={loanNameError} setError={setLoanNameError}
        />
        <InputSelectSF type='select' name='appFlavor' required={true} label='App flavor'
          value={appFlavor} optionList={appFlavorList}
          onChange={onAppFlavorChange} error={appFlavorError} setError={setAppFlavorError}
        />
        <InputSelectSF type='select' name='loanPurpose' required={true} label='Purpose'
          value={loanPurpose} optionList={sectorList}
          onChange={onLoanPurposeChange} error={loanPurposeError} setError={setLoanPurposeError}
        />
        <InputSelectSF type='select' name='loanType' required={true} label='Loan type'
          value={loanType} optionList={loanTypeList}
          onChange={onLoanTypeChange} error={loanTypeError} setError={setLoanTypeError}
        />
        <InputSelectSF type='select' name='loanSubType' required={true} label='Loan subtype'
          value={loanSubType} optionList={loanSubTypeList}
          onChange={onLoanSubTypeChange} error={loanSubTypeError} setError={setLoanSubTypeError}
        />
      </div>

      <div className='g_m_left_100'>
        <InputTextSF type='text' name='s_amt' required={true} maxLength={12}
          label='Requested amount (₹)'
          value={loanAmountF} onChange={onLoanAmountFChange}
          error={loanAmountFError} setError={setLoanAmountFError}
        />
        <InputTextSF type='text' name='s_tnr' required={true} maxLength={3}
          label='Tenure (months)'
          value={loanTenure} onChange={onTenureMonthsChange}
          error={tenureMonthsError} setError={setTenureMonthsError}
        />
        <InputCheckBoxUI label='Capital expenditure'
          onChange={onCapexChange} checked={capex}
          name='capex'
        />
      </div>
    </div>
  </ModalFormUI>

export default LoanUpdateModalUI
